/**
 * @flow
 * @relayHash 8cb8824fa100e913b4fcb26ce6883845
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type LeadSurvey_viewer$ref = any;
export type LeadSurveyRefetchQueryVariables = {|
  leadType?: ?string
|};
export type LeadSurveyRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: LeadSurvey_viewer$ref
  |}
|};
export type LeadSurveyRefetchQuery = {|
  variables: LeadSurveyRefetchQueryVariables,
  response: LeadSurveyRefetchQueryResponse,
|};
*/


/*
query LeadSurveyRefetchQuery(
  $leadType: String
) {
  viewer {
    ...LeadSurvey_viewer_MhPQS
    id
  }
}

fragment LeadSurvey_viewer_MhPQS on Viewer {
  leadSurvey(leadType: $leadType) {
    id
    plainId
    title
    description
    pages {
      id
      plainId
      title
      description
      displayOrder
      items {
        id
        plainId
        title
        description
        displayOrder
        type
        answerRequired
        answers {
          id
          plainId
          displayOrder
          type
          dataType
          title
        }
        otherAnswerAdd
        otherAnswerDisplayType
        otherAnswer {
          id
          plainId
          type
          dataType
          title
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "leadType",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "leadType",
    "variableName": "leadType"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "plainId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayOrder",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dataType",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LeadSurveyRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "LeadSurvey_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LeadSurveyRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "leadSurvey",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Survey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pages",
                "storageKey": null,
                "args": null,
                "concreteType": "SurveyPage",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SurveyItem",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "answerRequired",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "answers",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SurveyItemAnswer",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "otherAnswerAdd",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "otherAnswerDisplayType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "otherAnswer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SurveyItemAnswer",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "LeadSurveyRefetchQuery",
    "id": null,
    "text": "query LeadSurveyRefetchQuery(\n  $leadType: String\n) {\n  viewer {\n    ...LeadSurvey_viewer_MhPQS\n    id\n  }\n}\n\nfragment LeadSurvey_viewer_MhPQS on Viewer {\n  leadSurvey(leadType: $leadType) {\n    id\n    plainId\n    title\n    description\n    pages {\n      id\n      plainId\n      title\n      description\n      displayOrder\n      items {\n        id\n        plainId\n        title\n        description\n        displayOrder\n        type\n        answerRequired\n        answers {\n          id\n          plainId\n          displayOrder\n          type\n          dataType\n          title\n        }\n        otherAnswerAdd\n        otherAnswerDisplayType\n        otherAnswer {\n          id\n          plainId\n          type\n          dataType\n          title\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b2863d1fed57c2f29a131a6fdf1c142a';
module.exports = node;
